<template>
    <button
        v-tippy="t('editorToggleBold')"
        :class="[
            buttonState(
                editor.can().toggleBold() && editorSelection.text.length > 0,
                editor.isActive('bold'),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleBold() || editorSelection.text.length === 0"
        @click="editor.chain().focus().toggleBold().run()"
    >
        <MdiFormatBold class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatBold from 'materialdesignicons-vue3/icons/MdiFormatBold.js';

    defineExpose({
        name: 'BoldTextButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
        editorSelection: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
    const editorSelection = props.editorSelection;
</script>
